import { useParams } from 'react-router';
import useWorkshopStats from './useWorkshopStats';

interface RouteParams {
  publisherSlug: string;
  productId: string;
}

const useGetWorkshopStatsBasedOnRouteParams = () => {
  const { publisherSlug, productId } = useParams<RouteParams>();

  return useWorkshopStats({ publisherSlug, productId });
};

export default useGetWorkshopStatsBasedOnRouteParams;
